import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function SedBasics() {
    return (
        <div className={globalStyles.article}>
            <h1>sed basics</h1>
            <p>Stream editor — applies a command to each input line. Almost everything comes down to the
                substitute command, <code>s/pattern/replacement/flags</code>.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '550px'}}>
                    <thead>
                    <tr>
                        <th>Command</th>
                        <th>Effect</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>sed 's/foo/bar/' file</code></td>
                        <td>Replace the first match of <code>foo</code> per line</td>
                    </tr>
                    <tr>
                        <td><code>sed 's/foo/bar/g'</code></td>
                        <td>Replace every match per line</td>
                    </tr>
                    <tr>
                        <td><code>sed -i 's/foo/bar/g' file</code></td>
                        <td>Edit the file in place (GNU: <code>-i</code>, macOS/BSD: <code>-i ''</code>)</td>
                    </tr>
                    <tr>
                        <td><code>sed '2d' file</code></td>
                        <td>Delete line 2</td>
                    </tr>
                    <tr>
                        <td><code>sed '/^#/d' file</code></td>
                        <td>Delete lines starting with <code>#</code></td>
                    </tr>
                    <tr>
                        <td><code>sed -n '5,10p' file</code></td>
                        <td>Print only lines 5-10 (<code>-n</code> suppresses default auto-print)</td>
                    </tr>
                    <tr>
                        <td><code>sed 's/foo/bar/2'</code></td>
                        <td>Replace only the 2nd match per line</td>
                    </tr>
                    <tr>
                        <td><code>sed -e 'cmd1' -e 'cmd2'</code></td>
                        <td>Chain multiple commands</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Using a different delimiter</h3>
            <p>When the pattern itself contains <code>/</code> (like a file path), swap the delimiter to
                avoid a wall of backslashes.</p>
            <pre className={globalStyles.code}>
                <code>
                    sed 's#/usr/local#/opt#g' file
                </code>
            </pre>

            <h3>Capture groups</h3>
            <pre className={globalStyles.code}>
                <code>
                    <span style={{opacity: 0.7}}># Swap "First Last" to "Last, First"</span><br/>
                    echo "John Smith" | sed -E 's/(\w+) (\w+)/\2, \1/'<br/>
                    <span style={{opacity: 0.7}}># Smith, John</span>
                </code>
            </pre>
            <p><code>-E</code> (or <code>-r</code> on GNU sed) enables extended regex so groups/alternation
                don't need backslash-escaping.</p>
        </div>
    )
}
